export const DEFAULT_FLAG_PROP_KEY = 'isFeatureEnabled';
export const DEFAULT_FLAGS_PROP_KEY = 'featureToggles';
export const ALL_FLAGS_PROP_KEY = '@flopflip/flags';
